import { createSlice } from '@reduxjs/toolkit';
import { CAPTIONER_STATUS, CALL_STATUS } from 'CONSTANTS/enum';
interface IInitialState {
  callCaptions: any[];
  serverMessage: object;
  isCaptionerPresent: boolean;
  callStatus: string;
  captionerStatus: string;
}

const initialState: IInitialState = {
  callCaptions: [],
  serverMessage: {},
  isCaptionerPresent: false,
  callStatus: CALL_STATUS.DISCONNECTED,
  captionerStatus: CAPTIONER_STATUS.DISCONNECTED,

};

const captionsSlice = createSlice({
  name: 'captions',
  initialState,
  reducers: {
    setServerMessage: (state, action) => {
      state.serverMessage = action.payload;
    },
    setCaptions: (state, action) => {
      state.callCaptions = [...state.callCaptions, action.payload];
    },
    setIsCaptionerPresent: (state, action) => {
      state.isCaptionerPresent = action.payload;
    },
    setCallStatus: (state, action) => {
      state.callStatus = action.payload;
    },
    setCaptionerStatus: (state, action) => {
      state.captionerStatus = action.payload;
    },
    clearCaptions: (state) => {
      state.callCaptions = []
    }
  },
});

export const captionsActions = { ...captionsSlice.actions };

export const captionsSelector = {
  serverMessageSelector: (store: any) => store.captions.serverMessage,
  isCaptionerPresentSelector: (store: any) => store.captions.isCaptionerPresent,
  callStatusSelector: (store: any) => store.captions.callStatus,
  captionerStatusSelector: (store: any) => store.captions.captionerStatus,
  currentCaption: (store: any) =>
    store.captions.callCaptions[store.captions.callCaptions.length - 1],
};

export const captionSelector = (store: any) => store.captions.callCaptions;

export default captionsSlice.reducer;
